import { jsx as r } from "react/jsx-runtime";
import o from "../../assets/calendar.svg.js";
import { DateChip as t } from "./DateChip.js";
import { Value as a } from "./Value.js";
import { useTheme as i } from "@mui/joy";
const e = ({ children: e2, loading: s }) => {
  const m = i();
  return s ? r(a, { loading: true }) : e2 ? r(t, { icon: o, variant: "plain", value: e2, sx: { p: m.palette.isDarkMode ? "0 8px" : 0 } }) : "-";
};
export {
  e as Date,
  e as default
};
//# sourceMappingURL=Date.js.map
